<div class="d-flex align-items-center justify-content-end flex-nowrap gap-2">
  <base-language-switch class="ms-5"></base-language-switch>
  <div
    *ngIf="!is401"
    class="d-none d-xl-flex flex-nowrap justify-content-end gap-2"
  >
    <ng-container *ngFor="let link of portalSettings.links.visibility.header; trackBy: trackByLink">
      <base-button
        (btnClick)="goTo(portalSettings.links.urls[link])"
        [size]="buttonSizes.xs"
        [label]="link"
        color="dark"
      ></base-button>
    </ng-container>
  </div>
</div>
